/* =========================================================
   Kipor Ueber-uns-Hero – Zaehler
   Der Endwert steht serverseitig im HTML (ohne JS sichtbar).
   Sobald ein Zaehler ins Bild kommt, zaehlt er von 0 hoch.
   Bei prefers-reduced-motion bleibt der Endwert stehen.
   ========================================================= */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function format(n, sep) {
    var s = String(Math.round(n));
    if (!sep) return s;
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function run(el) {
    var target = parseFloat(el.getAttribute('data-kp-count')) || 0;
    var sep = el.getAttribute('data-kp-sep') || '';
    var duration = parseInt(el.getAttribute('data-kp-duration'), 10) || 1000;
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = format(target * eased, sep);
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function init(root) {
    if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
    var els = root.querySelectorAll('[data-kp-count]:not([data-kp-init])');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        run(entry.target);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) {
      el.setAttribute('data-kp-init', '');
      // Breite des Endwerts reservieren, damit beim Zaehlen nichts springt.
      el.style.minWidth = el.getBoundingClientRect().width + 'px';
      el.textContent = format(0, '');
      io.observe(el);
    });
  }

  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
